/**
 * px2rem converts pixels to rems
 *
 * @param {number} px
 *
 * @throws {Error}
 * @returns {string} remified string
 */
export const px2rem = (px, type = 'rem') => {
  const errorMessage = 'px must be a valid number to convert to rems';

  if (!px) {
    throw new Error(errorMessage);
  }

  const pixelsAsInt = parseInt(px, 10);

  if (Number.isNaN(pixelsAsInt)) {
    throw new Error(errorMessage);
  }

  return `${pixelsAsInt / 16}${type}`;
};

/**
 * clamp function to restrict numbers to a range
 *
 * @param {number} num to clamp
 * @param {number} max max value to clamp to
 *
 * @returns {number}
 */
export const clamp = (num, max) => Math.max(0, Math.min(max, num));
